import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from './ProductCard';

const ProductGrid = ({ heading = 'Featured Products', products = [] }) => {
  return (
    <section className="bg-black py-20 border-t border-zinc-900">
      <div className="max-w-[1480px] mx-auto px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-[#d4af37] tracking-[0.4em] text-xs uppercase mb-3">Shop</p>
            <h2 className="serif-italic gold-gradient-text text-5xl">{heading}</h2>
          </div>
          <Link to="/shop" className="text-[#d4af37] hover:underline serif-italic text-lg">View All Products</Link>
        </div>
        {products.length === 0 ? (
          <p className="text-zinc-500">Loading products…</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductGrid;
